// extracted by mini-css-extract-plugin
module.exports = {"join":"JoinButton_join__1hehU"};